















































































































import { Component, Vue } from 'vue-property-decorator';
import VehicleDetail from '@/models/VehicleDetail';
import { SelectedAttributeModel } from '../models/AttributeModel';
import { getModule } from 'vuex-module-decorators';
import StoreVuexModule from '@/stores/StoreVuexModule';

// components
import VehicleSelection from '@/components/VehicleSelection.vue';
import MatSelector from '@/components/MatSelector.vue';
import ConfirmMatSelection from '@/components/ConfirmMatSelection.vue';
import ProductNotFound from '@/components/ProductNotFound.vue';
import PatternNotFound from '@/components/PatternNotFound.vue';
import eventBus from '../common/bus';
import { trackAction } from '@/services/segment.service';

@Component({
  name: 'Home',
  components: {
    VehicleSelection,
    MatSelector,
    ConfirmMatSelection,
    ProductNotFound,
    PatternNotFound,
  },
})
export default class Home extends Vue {
  private gotoStep: number = 1;
  private vehicleDetail: VehicleDetail = new VehicleDetail();
  private selectedAttributes: SelectedAttributeModel[] = [];
  private currentWindowHeight: number = 0;
  private store = getModule(StoreVuexModule, this.$store);
  private productNotFound = false;
  private patternNotFound = false;

  private created() {
    eventBus.$on('track', (event: string, data: Record<string, unknown>) => {
      if (event === 'SearchVehicle') {
        trackAction(event, data);
      } else {
        trackAction(event, {
          ...data,
          vehicleKey: this.vehicleDetail &&
            this.vehicleDetail.make &&
            this.vehicleDetail.model && {
              make: this.vehicleDetail.make,
              model: this.vehicleDetail.model,
              key: `${this.vehicleDetail.make}|${this.vehicleDetail.model}`,
            },
        });
      }
    });
  }

  private mounted() {
    this.store.setRequiredUserRole('Kiosk');
    this.store.storeApiKey();
    this.store.storeParentOrigin();
    this.store.storeCompany();
    this.store.storeNoProgress();
    this.store.storeNoBack();
    this.store.storeNoManualLookup();
    this.store.storeNoProductRedirect();
    requestAnimationFrame(this.maintainWindowHeight);
  }

  private get authorised(): boolean {
    return this.store.apiKey !== '';
  }

  private get isVehicleDetailSet() {
    if (Object.keys(this.vehicleDetail).length > 0) {
      return true;
    }
    return false;
  }

  private get isSelectionSetSet() {
    if (
      Object.keys(this.vehicleDetail).length > 0 &&
      Object.keys(this.selectedAttributes).length
    ) {
      return true;
    }
    return false;
  }

  private updateVehicleDetail(detail: VehicleDetail) {
    this.vehicleDetail = detail;
  }

  private clickContinue(gotoStep: number) {
    this.gotoStep = gotoStep;
  }

  private setSelectedAttributes(data: any) {
    this.selectedAttributes = data.selectedAttributes;
    this.gotoStep = data.gotoStep;
  }

  private maintainWindowHeight() {
    const windowHeight = this.$el.clientHeight;
    if (windowHeight !== this.currentWindowHeight) {
      // send message
      if (this.store.parentOrigin) {
        window.parent.postMessage(
          { type: 'resize window', height: windowHeight },
          this.store.parentOrigin,
        );
        this.currentWindowHeight = windowHeight;
      }
    }
    requestAnimationFrame(this.maintainWindowHeight);
  }

  private onProductNotFound() {
    this.productNotFound = true;
  }

  private onPatternNotFound() {
    this.patternNotFound = true;
  }

  private resetScreen() {
    this.gotoStep = 1;
    this.vehicleDetail = new VehicleDetail();
    this.selectedAttributes = [];
    this.productNotFound = false;
    this.patternNotFound = false;
  }
}
